import { CssProp, Styles } from '@core/utils/css';
import { ClassNames, css } from '@emotion/react';
import DialogContent from '@material-ui/core/DialogContent';
import React, { memo, PropsWithChildren, RefObject } from 'react';
import { FormContainer, FormContainerProps } from '../form';
import { R } from '@core/utils/r';

const styles = {
  container: css`
    line-height: 1.5;
    position: relative;

    color: #20455e;
  `,

  fullHeight: css`
    height: 60vh;
  `,

  noPadding: css`
    padding: 0;
  `,

  tabContent: css`
    padding: 0;
  `,

  tabContentFullHeight: css`
    overflow: hidden;

    > div,
    form {
      ${Styles.absoluteFill};
    }
  `,
};

export interface ModalContentProps {
  customCss?: CssProp;
  fullHeight?: boolean;
  noPadding?: boolean;
  tabContent?: boolean;
  formContainer?: boolean | FormContainerProps;
  containerRef?: RefObject<HTMLElement>;
  id?: string;
}

export const ModalContent = memo((props: PropsWithChildren<ModalContentProps>) => {
  let children = props.children;

  if (R.isObject(props.formContainer)) {
    children = <FormContainer {...props.formContainer}>{children}</FormContainer>;
  }

  return (
    <ClassNames>
      {({ css }) => (
        <DialogContent
          innerRef={props.containerRef}
          id={props.id}
          classes={{
            // @ts-ignore
            root: css(
              styles.container,
              props.fullHeight && styles.fullHeight,
              props.noPadding && styles.noPadding,
              props.tabContent && styles.tabContent,
              props.tabContent && props.fullHeight && styles.tabContentFullHeight,
              props.customCss,
            ),
          }}
        >
          {children}
        </DialogContent>
      )}
    </ClassNames>
  );
});
